/**
 * FikoMuayene Dialog — Muayene/Kalite Raporu (FAI/PPAP) UI
 * Nominal±tol vs ölçülen → geç/kal tablosu. Modelden (bbox+delikler) otomatik karakteristik + FAI yazdırma.
 */
import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import * as THREE from 'three';
import { MuayeneKarakter, karakterDurum, muayeneOzet, MuayeneOzet } from './FikoMuayene';
import { ozellikleriTani } from '../fiko-feature-tani/FikoFeatureTani';
import { baglamOku } from '../fiko-uretim-baglam/UretimBaglam';
import { KalicilikService } from '../fiko-kalicilik/kalicilik.service';

@Component({
  selector: 'fikoyt-muayene',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule],
  template: `
  <div class="mu">
    <div class="mu-bilgi">
      <input [(ngModel)]="parcaAd" placeholder="Parça adı">
      <input [(ngModel)]="parcaNo" placeholder="Parça no">
      <input [(ngModel)]="revizyon" placeholder="Rev">
    </div>
    <div class="mu-arac">
      <button class="mu-mini" (click)="modeldenOlustur()">⊕ Modelden Oluştur</button>
      <button class="mu-mini" (click)="ekle()">＋ Satır</button>
    </div>
    <div class="mu-tablo">
      <div class="mu-th"><span>#</span><span>Karakteristik</span><span>Nom.</span><span>+Tol</span><span>−Tol</span><span>Ölçülen</span><span>Durum</span><span></span></div>
      @for (k of liste; track $index) {
        <div class="mu-tr" [class.gec]="durum(k)==='gec'" [class.kal]="durum(k)==='kal'">
          <span class="mu-no">{{ k.no }}</span>
          <input [(ngModel)]="k.ad" class="ad">
          <input type="number" [(ngModel)]="k.nominal" (ngModelChange)="yenile()">
          <input type="number" [(ngModel)]="k.tolUst" (ngModelChange)="yenile()" step="0.05">
          <input type="number" [(ngModel)]="k.tolAlt" (ngModelChange)="yenile()" step="0.05">
          <input type="number" [(ngModel)]="k.olculen" (ngModelChange)="yenile()" class="olc">
          <span class="mu-dur" [class.g]="durum(k)==='gec'" [class.k]="durum(k)==='kal'">{{ durumEt(k) }}</span>
          <button class="mu-sil" (click)="sil($index)">✕</button>
        </div>
      }
      @if (!liste.length) { <div class="mu-bos">Karakteristik ekleyin veya "Modelden Oluştur".</div> }
    </div>

    @if (liste.length) {
      <div class="mu-ozet" [class.kabul]="ozet.sonuc==='KABUL'" [class.red]="ozet.sonuc==='RED'">
        <div class="mu-sonuc">{{ ozet.sonuc }}</div>
        <div class="mu-say">Toplam {{ ozet.toplam }} · Geçen {{ ozet.gecen }} · Kalan {{ ozet.kalan }} · Eksik {{ ozet.bos }}</div>
      </div>
      <button class="mu-btn kaydet" (click)="kaydet()">💾 Muayeneyi Kaydet</button>
      @if (kayitDurum) { <div class="mu-kayit-durum">{{ kayitDurum }}</div> }
      <button class="mu-btn" (click)="yazdir()">🖨️ FAI Raporu Yazdır / PDF</button>
    }
    @if (hata) { <div class="mu-hata">{{ hata }}</div> }
  </div>
  `,
  styles: [`
    .mu { padding:10px; min-width:360px; max-width:440px; font-size:11px; color:#e6f6ff;
      background:linear-gradient(180deg,rgba(0,40,60,.96),rgba(0,18,36,.98)); border-radius:6px; }
    .mu-bilgi { display:grid; grid-template-columns:2fr 1.4fr 0.8fr; gap:5px; margin-bottom:6px; }
    .mu-bilgi input, .mu-tr input { background:rgba(0,60,80,.8); border:1px solid rgba(0,200,220,.35); color:#fff; padding:4px; border-radius:4px; font-size:10px; outline:none; box-sizing:border-box; width:100%; }
    .mu-arac { display:flex; gap:6px; margin-bottom:6px; }
    .mu-mini { background:rgba(0,90,110,.6); border:1px solid rgba(0,200,220,.4); color:#bdf; border-radius:4px; padding:4px 10px; font-size:10px; cursor:pointer; }
    .mu-mini:hover { background:rgba(0,130,160,.8); }
    .mu-tablo { display:flex; flex-direction:column; gap:2px; max-height:300px; overflow:auto; }
    .mu-th, .mu-tr { display:grid; grid-template-columns:24px 1.6fr 50px 44px 44px 56px 44px 20px; gap:3px; align-items:center; }
    .mu-th { color:#7fc6dd; font-size:9px; padding:0 2px; }
    .mu-tr { padding:2px 0; border-radius:3px; }
    .mu-tr.gec { background:rgba(0,200,120,.1); } .mu-tr.kal { background:rgba(255,70,70,.14); }
    .mu-no { text-align:center; color:#9fe8f7; }
    .mu-tr input.ad { text-align:left; } .mu-tr input.olc { background:rgba(0,90,70,.6); }
    .mu-dur { font-size:9px; text-align:center; font-weight:700; }
    .mu-dur.g { color:#7dffc0; } .mu-dur.k { color:#ff8c8c; }
    .mu-sil { background:rgba(120,40,40,.6); border:1px solid rgba(255,100,100,.4); color:#ff9a9a; border-radius:4px; cursor:pointer; }
    .mu-bos { padding:8px; text-align:center; color:#9fe8f7; opacity:.7; }
    .mu-ozet { margin-top:8px; padding:8px; border-radius:5px; display:flex; align-items:center; gap:12px; background:rgba(0,0,0,.35); border:1px solid rgba(0,200,220,.3); }
    .mu-ozet.kabul { background:rgba(0,200,120,.18); border-color:rgba(0,255,150,.5); }
    .mu-ozet.red { background:rgba(255,60,60,.18); border-color:rgba(255,120,120,.5); }
    .mu-sonuc { font-size:18px; font-weight:800; } .mu-ozet.kabul .mu-sonuc { color:#7dffc0; } .mu-ozet.red .mu-sonuc { color:#ff8c8c; }
    .mu-say { font-size:10px; color:#cfeaf5; }
    .mu-btn { width:100%; padding:8px; margin-top:6px; border:none; border-radius:5px; font-weight:600; cursor:pointer; color:#fff; background:linear-gradient(90deg,#0a84c0,#0bb39e); }
    .mu-btn.kaydet { background:linear-gradient(90deg,#1f9e5a,#34c77b); }
    .mu-kayit-durum { font-size:10px; color:#7dffc0; text-align:center; margin-top:2px; }
    .mu-hata { margin-top:8px; padding:6px; background:rgba(255,50,50,.2); border:1px solid rgba(255,100,100,.4); border-radius:4px; color:#ff9a9a; text-align:center; }
  `]
})
export class FikoMuayeneComponent {
  @Input() anaGosterim: any = null;
  @Input() pencere: any;
  @Input() ayarlar: any = {};
  @Input() modelleme: any = null;

  parcaAd = ''; parcaNo = ''; revizyon = 'A';
  liste: MuayeneKarakter[] = [];
  ozet: MuayeneOzet = { toplam: 0, gecen: 0, kalan: 0, bos: 0, sonuc: 'EKSİK' };
  hata: string | null = null;

  private kalicilik = inject(KalicilikService);
  kayitDurum = '';

  constructor(private cd: ChangeDetectorRef) {
    const yuk = this.kalicilik.yuklenecekAl('muayene');
    if (yuk) { Object.assign(this, yuk); this.ozet = muayeneOzet(this.liste); return; }
    const b = baglamOku();   // önceki analizden (dashboard/özellik tanıma) parça → otomatik form
    if (b.guncel) this.baglamdanOlustur(b);
  }

  /** Muayene raporunu DB + local'e kaydet. */
  async kaydet(): Promise<void> {
    if (!this.liste.length) { this.kayitDurum = 'Karakteristik ekleyin'; this.cd.detectChanges(); return; }
    const veri = { parcaAd: this.parcaAd, parcaNo: this.parcaNo, revizyon: this.revizyon, liste: this.liste };
    this.kayitDurum = 'Kaydediliyor…'; this.cd.detectChanges();
    const k = await this.kalicilik.kaydet('muayene', (this.parcaAd || 'Muayene') + ' · ' + this.ozet.sonuc, veri);
    this.kayitDurum = k._sync ? '✓ Kaydedildi (DB)' : '✓ Kaydedildi (yerel)'; this.cd.detectChanges();
  }

  /** Bağlamdaki ölçü + deliklerden muayene karakteristikleri (model ölçmeden). */
  private baglamdanOlustur(b: any): void {
    const tol = (v: number) => Math.max(0.1, +(v * 0.005).toFixed(2));
    const ekle = (ad: string, nom: number) => this.liste.push({ no: this.liste.length + 1, ad, nominal: +nom.toFixed(2), tolUst: tol(nom), tolAlt: -tol(nom), olculen: null, birim: 'mm' });
    const olc = String(b.olcu || '').split(/[×x]/).map((s: string) => parseFloat(s)).filter((n: number) => n > 0);
    if (olc[0]) ekle('Genel En (X)', olc[0]); if (olc[1]) ekle('Genel Boy (Y)', olc[1]); if (olc[2]) ekle('Genel Yükseklik (Z)', olc[2]);
    let dn = 1; for (const cap of (b.delikler || [])) ekle(`Delik Ø${dn++}`, cap);
    this.ozet = muayeneOzet(this.liste);   // constructor: detectChanges YOK
  }

  durum(k: MuayeneKarakter) { return karakterDurum(k).durum; }
  durumEt(k: MuayeneKarakter): string { const d = karakterDurum(k); return d.durum === 'gec' ? 'GEÇ' : d.durum === 'kal' ? 'KAL' : '—'; }
  yenile(): void { this.ozet = muayeneOzet(this.liste); this.cd.detectChanges(); }

  ekle(): void { this.liste.push({ no: this.liste.length + 1, ad: 'Karakteristik ' + (this.liste.length + 1), nominal: 0, tolUst: 0.1, tolAlt: -0.1, olculen: null, birim: 'mm' }); this.yenile(); }
  sil(i: number): void { this.liste.splice(i, 1); this.liste.forEach((k, j) => k.no = j + 1); this.yenile(); }

  /** Aktif modelden karakteristik üret: genel boyutlar (X/Y/Z) + tanınan delik çapları. */
  modeldenOlustur(): void {
    const mesh = this.modelleme?.govdeMesh || this.anaGosterim?.modelleme?.govdeMesh;
    if (!mesh) { this.hata = 'Aktif model yok'; this.cd.detectChanges(); return; }
    this.hata = null; this.liste = [];
    const b = new THREE.Box3().setFromObject(mesh); const s = new THREE.Vector3(); b.getSize(s);
    const tol = (v: number) => Math.max(0.1, +(v * 0.005).toFixed(2));   // ±%0.5 (min 0.1) varsayılan tolerans
    const ekle = (ad: string, nom: number, birim = 'mm') => this.liste.push({ no: this.liste.length + 1, ad, nominal: +nom.toFixed(2), tolUst: tol(nom), tolAlt: -tol(nom), olculen: null, birim });
    ekle('Genel En (X)', s.x); ekle('Genel Boy (Y)', s.y); ekle('Genel Yükseklik (Z)', s.z);
    try {
      const oz = ozellikleriTani(mesh);
      let dn = 1;
      for (const o of oz) if (o.tip === 'delik' && o.cap) ekle(`Delik Ø${dn++}`, o.cap);
    } catch { }
    this.yenile();
  }

  yazdir(): void {
    if (!this.liste.length) return;
    const tarih = new Date().toLocaleDateString('tr-TR');
    const w = window.open('', '_blank', 'width=900,height=1000');
    if (!w) { this.hata = 'Yazdırma penceresi açılamadı (popup engeli)'; this.cd.detectChanges(); return; }
    const satir = (k: MuayeneKarakter) => {
      const d = karakterDurum(k);
      const renk = d.durum === 'gec' ? '#1a8f4a' : d.durum === 'kal' ? '#c0392b' : '#888';
      const et = d.durum === 'gec' ? 'GEÇ' : d.durum === 'kal' ? 'KAL' : '—';
      return `<tr><td>${k.no}</td><td style="text-align:left">${k.ad}</td><td>${k.nominal}</td><td>${k.tolUst >= 0 ? '+' : ''}${k.tolUst}</td><td>${k.tolAlt}</td>
      <td>${k.olculen ?? '—'}</td><td>${d.durum !== 'bos' ? (d.sapma >= 0 ? '+' : '') + d.sapma.toFixed(3) : '—'}</td>
      <td style="color:#fff;font-weight:700;background:${renk}">${et}</td></tr>`;
    };
    const oz = muayeneOzet(this.liste);
    const sonRenk = oz.sonuc === 'KABUL' ? '#1a8f4a' : oz.sonuc === 'RED' ? '#c0392b' : '#b8860b';
    w.document.write(`<!doctype html><html lang="tr"><head><meta charset="utf-8"><title>FAI Raporu</title>
    <style>body{font-family:Segoe UI,Arial,sans-serif;color:#13283a;padding:28px;max-width:820px;margin:auto}
    h1{color:#0a84c0;margin:0 0 4px} .sub{color:#789;margin-bottom:16px;font-size:13px}
    .meta{display:flex;gap:24px;margin-bottom:18px;font-size:13px} .meta b{color:#0a84c0}
    table{width:100%;border-collapse:collapse;font-size:13px} th,td{padding:7px 8px;border:1px solid #cdd9e3;text-align:center}
    th{background:#0a84c0;color:#fff} .sonuc{margin-top:20px;padding:12px;text-align:center;font-size:22px;font-weight:800;color:#fff;background:${sonRenk};border-radius:6px}
    .foot{margin-top:20px;font-size:12px;color:#789} .imza{margin-top:36px;display:flex;justify-content:space-between;font-size:13px}</style></head><body>
    <h1>İlk Parça Onay Raporu (FAI)</h1><div class="sub">FikoYT 3D Sistem · Tarih: ${tarih}</div>
    <div class="meta"><div><b>Parça:</b> ${this.parcaAd || '—'}</div><div><b>Parça No:</b> ${this.parcaNo || '—'}</div><div><b>Revizyon:</b> ${this.revizyon || '—'}</div></div>
    <table><tr><th>#</th><th>Karakteristik</th><th>Nominal</th><th>+Tol</th><th>−Tol</th><th>Ölçülen</th><th>Sapma</th><th>Sonuç</th></tr>
    ${this.liste.map(satir).join('')}</table>
    <div class="sonuc">SONUÇ: ${oz.sonuc} (${oz.gecen}/${oz.toplam} geçti)</div>
    <div class="imza"><div>Ölçen: ____________________</div><div>Onaylayan: ____________________</div></div>
    <div class="foot">Bu rapor FikoYT 3D Sistem ile oluşturulmuştur.</div>
    <script>window.onload=()=>window.print()</script></body></html>`);
    w.document.close();
  }
}
